import React from 'react';
import IconToolTip from '../../../common/IconToolTip';

export default function StatusLabel(props) {
    const { onClick = () => { }, content, color, shownNobgLabel, titleText = 'Status', hoverText, labelClass = 'bg-white' } = props;

    const lookUp = {
        undefined: ` text-font08  px-p-1 rounded-3px  border border-l-4 border-${color} ${labelClass}`,
        true: `text-font08 px-1 rounded-md px-2${labelClass}`,
    };

    return (
        <>
            <div onClick={onClick} className='flex flex-wrap gap-1 items-center p-1'>
                <IconToolTip title={`${titleText}: ${hoverText || content}`}>
                    <span className={`max-w-9rem truncate p-1  items-center  mr-2  text-${color} capitalize  ${lookUp[shownNobgLabel]} `}>{content}</span>
                </IconToolTip>
            </div>
        </>
    );
}
